import type { Component, Entity2D, Vector2 } from '../../odie';

import { mapToViewPosition } from '../util/mapTools';

// types
//-----------------------------------------------------------------------------
export type PositionComponentOptions = {
  position: Vector2;
};

/*
    declares map position. this can include coordiantes outside the map.
*/
export class PositionComponent implements Component {
  // constants
  //-------------------------------------------------------------------------
  public static readonly NAME = 'position';

  // fields
  //-------------------------------------------------------------------------
  // injected
  public entity!: Entity2D;
  // state
  private _mapPosition!: Vector2;

  /** Optional callback invoked when map position changes */
  public onPositionChange?: (position: Vector2) => void;

  // properties
  //-------------------------------------------------------------------------
  public get mapPosition(): Vector2 {
    return this._mapPosition;
  }

  public set mapPosition(position: Vector2) {
    // set map position
    this._mapPosition = position;

    // get view position
    const viewPosition = mapToViewPosition(position);

    // commit view position
    this.entity.view.x = viewPosition.x;
    this.entity.view.y = viewPosition.y;

    // set modified
    this.entity.setModified(PositionComponent, { mapPosition: true });

    // invoke callback if set
    this.onPositionChange?.(position);
  }

  // impl
  //-------------------------------------------------------------------------
  public init(options: PositionComponentOptions): void {
    this.mapPosition = options.position;
  }
}
